import ComposerInserter from '@intercom/embercom-composer/components/composer-inserter';
export default ComposerInserter;
